import { connect } from 'react-redux';
import { Instances, SideBarTypes } from '../../../../../constants';
import { IStateType } from '../../../../../store/models/root.interface';
import { makeSelectObject, requestObject } from '../../../../../store/Object';
import { closeSideBar, getParams, openSideBar } from '../../../../../store/sidebar';
import ConfigurationEdit, { DispatchPropsType, MapStateType } from '../../organisms/receiveMessage/editConfigurations';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { updateSelectedTemplate } from '../../../../../store/actions/receiveMessage.action';
import { makeSelectObjectsArray, requestObjects } from '../../../../../store/Objects';
import { getData } from '../../../../../store/actions/SMSTemplates.action';

const mapStateToProps = (state: IStateType) => ({
    id: getParams(state),
    configurationList: makeSelectObjectsArray(Instances.vmnConfigurationListing)(state),
    templateData: state.SMSTemplates,
    callbackProfileList: makeSelectObjectsArray(Instances.callbackProfiles)(state),
    selectedTemplateId: state.receiveMessage.selectedTemplateId,
    selectedUrlId: state.receiveMessage.selectedUrlId,
    createdUrl: state.receiveMessage.createdUrl,
    templatesData: makeSelectObjectsArray(Instances.smsTemplate)(state),
    urlList: makeSelectObjectsArray(Instances.urlShortenerList)(state) || {},
    profile: state.profile,
    countryList: makeSelectObject(Instances.countryList)(state) || [],
})

const mapDispatchToProps = {
    onLoad: () => requestObjects(Instances.vmnConfigurationListing),
    onClose: () => closeSideBar(),
    onLoadUrls: () => requestObjects(Instances.urlShortenerList, undefined, { page: true }),
    onLoadTemplates: () => getData(),
    loadCallbackProfiles: () => requestObjects(Instances.callbackProfiles, undefined, { limit: 1000 }),
    onSave: (formData: any, successCallback: (res: any, flag: boolean) => void) => requestObject(Instances.vmnConfigurationListing, undefined, undefined, 'PUT', true, true, formData, (response: any, flag: boolean) => successCallback(response, flag)),

    onSelectTemplate: (templatesData: any, sidebarType: string, getSidebarType: (type: string) => void) => openSideBar(SideBarTypes.configurationSelectTemplate, { extraParam: { data: templatesData, type: sidebarType, getSidebarType: (type: string) => getSidebarType(type) } }),
    onSelectUrl: (urlData: any, sidebarType: string, getSidebarType: (type: string) => void) => openSideBar(SideBarTypes.SelectUrl, { extraParam: { data: urlData, type: sidebarType, getSidebarType: (type: string) => getSidebarType(type) } }),
    onSaveNewConfiguration: (formData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.vmnConfigurationListing, undefined, undefined, 'post', true, true, formData, (response: any, flag: boolean) => callback(response, flag)),
    onLoadRecepientNumbers: () => requestObjects(Instances.vmnRecepientNumbers, { service_id: 1 }, undefined, false, true, undefined, undefined, undefined),
    fetchCountryList: () => requestObject(Instances.countryList),
    updateSelectedTemplateInStore: (templateId: string) => updateSelectedTemplate(templateId)
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(ConfigurationEdit));